/**
 * users模块接口列表
 */
import Vue from "vue";
import axios from '@/utils/http';
const users = {

  //得到生产厂家{code}
  info(code) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/maker/`+code, {
      mask:false
    });
  }
}

export default users;



// WEBPACK FOOTER //
// ./src/api/maker.js